import avatar from "./avatar.svg";
import placeholder from "./placeholder.svg";
import shombriddhi from "./shombriddhi_logo.svg";
import signature from "./signature.svg";

const IMAGES = {
  placeholder,
  shombriddhi,
  avatar,
  signature,
  logo: "/images/logo.svg",
};

export default IMAGES;
